import { useState } from 'react';

const ZOOM_STEPS = [0.5, 0.6, 0.7, 0.85, 1, 1.25, 1.5] as const;
const DEFAULT_ZOOM_INDEX = ZOOM_STEPS.indexOf(1);

export interface ZoomState {
  zoom: number;
  canZoomOut: boolean;
  canZoomIn: boolean;
  zoomOut: () => void;
  zoomIn: () => void;
  resetZoom: () => void;
}

/**
 * Discrete zoom steps for a document viewer; 100% is native sizing. Owned by
 * whoever renders `ZoomControls`, so a page can put them in its own toolbar
 * and hand the state to the viewer.
 */
export function useZoom(): ZoomState {
  const [zoomIndex, setZoomIndex] = useState(DEFAULT_ZOOM_INDEX);
  return {
    zoom: ZOOM_STEPS[zoomIndex] ?? 1,
    canZoomOut: zoomIndex > 0,
    canZoomIn: zoomIndex < ZOOM_STEPS.length - 1,
    zoomOut: () => setZoomIndex((i) => Math.max(0, i - 1)),
    zoomIn: () => setZoomIndex((i) => Math.min(ZOOM_STEPS.length - 1, i + 1)),
    resetZoom: () => setZoomIndex(DEFAULT_ZOOM_INDEX),
  };
}
